import template from './step-6.html';

class StepSixthComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    SchoolCommonRoomService,
    ActivityService,
    UtilService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.ActivityService = ActivityService;
    this.UtilService = UtilService;

    this.mySchoolCommonRoom = {};
    this.schoolYear = 0;
    this.schoolNextYear = 0;
    this.schoolYearText = '';
    this.months = [];
  }

  $onInit() {
    this.mySchoolCommonRoom = this.SchoolCommonRoomService.getMySchoolCommonRoom();
    this.schoolYear = parseInt(this.mySchoolCommonRoom.schoolYear, 10);
    this.schoolNextYear = this.schoolYear + 1;
    this.schoolYearText = this.schoolYear + '/' + this.schoolNextYear;

    this.months = this.UtilService.getAllMonths();
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.activities) {
      this.activities = Object.assign([], this.activities);
    }
  }
}

export const StepSixth = {
  bindings: {
    me: '<',
    activities: '<'
  },
  template,
  controller: StepSixthComponent
};
